function base() {
	initSmoothScrollAnimation();
	initPreviousReports();
	initTooltips();
	initRevealOnScrollAnimations();
	initCookies();
}
